import "./infoWidget.css";
import React, { Fragment, useState } from 'react';
import Slider, { SliderTooltip } from 'rc-slider';
import Button1 from "../button/Button1";
import Button from 'react-bootstrap/Button'
import '../button/button1.css'
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';


const wrapperStyle = { width: 400, margin: 50 };

export default function InfoWidget() {

{/**const showModal = [modal, setModal] = useState(False);**/}

  return (
    <div className="widgetLg">
  
      <h1>Welcome To the CNSP Neural Analysis Platform</h1>
      <h2>Sections</h2>
      <ul>
          <li>Encoding</li>
          <li>Decoding</li>
      </ul>
      <h2>Encoding</h2>
      <ul>
      <li><h3>TRF/STRF Estimation</h3></li>
      <p>Here, we estimate a 16-channel spectro-temporal response function (STRF) from 2 minutes of EEG data recorded while a human participant listened to natural speech. To map in the forward direction (encoding model), we set the direction of causality to 1. To capture the entire STRF timecourse, the time lags are computed between -100 and 400 ms. The regularization parameter is set to 0.1 to reduce overfitting to noise.</p>
      <p>We compute the broadband TRF by averaging the STRF model across frequency channels and the global field power (GFP) by taking the standard deviation across EEG channels, and plot them as a function of time lags. This example can also be generated using plot_speech_STRF and plot_speech_TRF.</p>
     </ul>

      <h2>Decoding</h2>
      <ul>
          <li><h3>Stimulus Reconstruction</h3></li>
          <p>Here, we build a neural decoder that can reconstruct the envelope of the speech stimulus heard by the EEG participant. First, we downsample the data and partition it into 6 equal segments for training (segments 2 to 6) and testing (segment 1).</p>
            <p>To optimize the decoders ability to predict stimulus features from new EEG data, we tune the regularization parameter using an efficient leave-one-out cross-validation (CV) procedure.</p>
            <p> Based on the CV results, we train our model using the optimal regularization value and test it on the held-out test set. Model performance is evaluated by measuring the correlation between the original and predicted stimulus.</p>
            <p>We plot the CV metrics as a function of regularization and the test results of the final model. This example can also be generated using stimulus_reconstruction.</p>

          <li><h3>Single-lag decoder analysis</h3></li>
          <p>Here, we evaluate the contribution of individual time lags towards stimulus reconstruction using a single-lag decoder analysis. First, we downsample the data and partition it into 5 equal segments.</p>
          <p>We run a leave-one-out cross-validation to test a series of single-lag decoders over the range 0 to 1000 ms using a pre-tuned regularization parameter.</p>
          <p>We plot the reconstruction accuracy and error as a function of time lags. This example can also be generated using single_lag_analysis.</p>
        </ul>
    </div>
  );
}